import React, { useState } from 'react';
import clsx from 'clsx';
import { usePoster } from '../PosterContext';

const POSTER_SRC = "https://storage.googleapis.com/escape-bar-firebase.appspot.com/static/goty2024/poster6.png";
const POSTER_TITLE = "光頭村";
const POSTER_DESC = "腦洞大開 笑聲不斷";

const VARIANT_SRC = "https://storage.googleapis.com/escape-bar-firebase.appspot.com/static/goty2024/poster6v.jpg";
const VARIANT_DESC = "引光照世 撥雲見日";

const PosterModal6 = ({ isOpen, onClose }) => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isLightOn, setIsLightOn] = useState(false);

  const { isGameEnabled } = usePoster();

  const handleMouseMove = (e) => {
    if (!isGameEnabled) return;
    
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    
    setMousePosition({ x, y });
    setIsLightOn(true);
  };

  const handleTouch = (e) => {
    if (!isGameEnabled) return;
    
    const rect = e.currentTarget.getBoundingClientRect();
    const touch = e.touches[0];
    const x = touch.clientX - rect.left;
    const y = touch.clientY - rect.top;
    
    setMousePosition({ x, y });
    setIsLightOn(true);
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[2000] flex items-center justify-center transition-all"
      style={{
        backgroundImage: `url('/img/goty2024/hero-bricks.png')`,
        backgroundRepeat: 'repeat',
        backgroundColor: 'rgba(0,0,0,0.90)',
      }}
      onClick={onClose}
    >
      <button
        className="absolute top-4 right-4 text-white text-3xl font-bold z-60"
        onClick={(e) => { e.stopPropagation(); onClose(); }}
        aria-label="關閉"
      >
        ×
      </button>
      <div
        className="flex flex-col items-center justify-between relative"
        onClick={e => e.stopPropagation()}
      >
        <div
          className="w-[calc(100%+2rem)] md:w-[calc(100%+4rem)] bg-[#DFB750] text-center border-x-8 border-b-8 border-solid border-black mr-[-1rem] ml-[-1rem] md:mr-[-2rem] md:ml-[-2rem]"
        >
          <h2 className="text-2xl md:text-3xl font-bold tracking-wide text-black py-2 md:py-4">
            {POSTER_TITLE}
          </h2>
        </div>
        <div className="relative w-80 md:w-auto h-auto md:h-[75vh]">
          {isGameEnabled ? (
            <div 
              className="relative w-full h-full cursor-crosshair"
              onMouseMove={handleMouseMove}
              onTouchMove={handleTouch}
              onTouchStart={handleTouch}
            >
              <img src={VARIANT_SRC} alt="Variant Poster" className="object-contain w-full h-full mx-auto border-x-8 border-b-8 border-solid border-black shadow-2xl" />
              {/* 黑色遮罩 */}
              <div 
                className="absolute inset-0 bg-black"
                style={{
                  background: isLightOn 
                    ? `radial-gradient(circle 80px at ${mousePosition.x}px ${mousePosition.y}px, transparent 0%, rgba(0,0,0,0.3) 40px, rgba(0,0,0,0.8) 60px, rgba(0,0,0,1) 80px)`
                    : 'rgba(0,0,0,1)'
                }}
              />
            </div>
          ) : (
            <img src={POSTER_SRC} alt={POSTER_TITLE} className="object-contain w-full h-full mx-auto border-x-8 border-b-8 border-solid border-black shadow-2xl" />
          )}
        </div>
        <div className="mt-6 text-center">
          <p className={clsx("text-xl md:text-2xl font-bold tracking-widest shadow-2xl", {
            'text-white': !isGameEnabled,
            'text-black': isGameEnabled
          })}>
            {isGameEnabled ? VARIANT_DESC : POSTER_DESC}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PosterModal6;
